import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import { BankListOptions } from '../../../common/constants/BankList';
import PopUp from '../../../common/components/PopUp/PopUp';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import get from 'lodash/get';
import {
  getBankCities,
  getBankBranch,
  getBankBranchContact,
  sendMailToBank
} from '../../../common/constants/api';
import * as Yup from 'yup';
const validationSchema = Yup.object().shape({
  city: Yup.string().required('Required'),
  bankname: Yup.string().required('Required')
});
const SendToBank = props => {
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading');
  const [show, setShow] = useState(false);
  const [status, setStatus] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const [bankListOptions, setBankListOptions] = useState([]);
  const [branchContact, setBranchContact] = useState('');
  const errorHandle = err => {
    setShow(true);
    setType('fail');
    setStatus(err?.response?.data?.status);
    setText(
      err?.response?.data?.message
        ? err?.response?.data?.message
        : 'Something went wrong'
    );
  };
  const resetState = () => {
    setShow(true);
    setType('loading');
    setText('Loading');
    setStatus(false);
  };
  useEffect(() => {
    resetState();
    getBankCities()
      .then(res => {
        setShow(false);
        let cities = [];
        res?.map(item => {
          let city = {
            value: item.id,
            label: item.name
          };
          cities.push(city);
        });
        setCityOptions(cities);
      })
      .catch(err => {
        errorHandle(err);
      });
  }, []);
  const onCityChange = e => {
    resetState();
    getBankBranch(e.value)
      .then(res => {
        setShow(false);
        let banks = [];
        res?.map(item => {
          let bank = {
            value: item.id,
            label: item.bankName
          };
          banks.push(bank);
        });
        setBankListOptions(banks);
      })
      .catch(err => {
        errorHandle(err);
      });
  };
  const onBankChange = e => {
    let applicant = getApplicantionInfo();
    resetState();
    getBankBranchContact(e.value, applicant.leadId)
      .then(res => {
        setShow(false);
        setBranchContact(res);
      })
      .catch(err => {
        errorHandle(err);
      });
  };
  const sendEmailToBank = () => {
    let applicant = getApplicantionInfo();
    resetState();
    sendMailToBank(applicant.leadId, branchContact.id)
      .then(res => {
        setType('success');
        setText('Email has been sent successfully!');
        closeMessage();
      })
      .catch(err => {
        errorHandle(err);
      });
  };
  const closeMessage = () => {
    setTimeout(() => {
      props.setShowParrent(false);
    }, 2000);
  };
  return (
    <Formik
      initialValues={{
        city: { value: '', label: 'Select City' },
        bankname: { value: '', label: 'Select Bank' }
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
        sendEmailToBank();
      }}
    >
      {({
        values,
        handleChange,
        errors,
        touched,
        handleBlur,
        setFieldError,
        setFieldValue,
        setFieldTouched,
        handleSubmit,
        isSubmitting
      }) => {
        return (
          <Form className="w-full" onSubmit={handleSubmit}>
            <div className="bg-white py-8 md:py-1 p-2 ">
              <div className="flex-1  w-full">
                <p className="font-roboto font-normal text-black text-lg">
                  Details
                </p>
                <div className="w-full"></div>
                <div className="md:flex block ">
                  <div className="w-full pt-10">
                    <div className="font-normal font-roboto text-sm text-black-500">
                      <CommonSelect sort={true}
                        name="city"
                        value={values.city}
                        onChange={e => {
                          setFieldValue('city', {
                            value: e.value,
                            label: e.label
                          });
                          onCityChange(e);
                        }}
                        onBlur={() => {
                          setFieldTouched('city', true, true);
                        }}
                        options={cityOptions}
                        isHoverEffect
                        stylesContainer={{
                          marginBottom: '0px',
                          fontSize: '40px',
                          height: '52px'
                        }}
                        dropdownStyle={{
                          top: '52px',
                          color: 'rgba(0,0,0,0.87)',
                          fontSize: '16px',
                          backgroundColor: '#fff',
                          alignItems: 'center',
                          fontFamily: 'Roboto',
                          fontWeight: 400
                        }}
                        styleText={{
                          fontSize: '14px',
                          padding: '0 6px',
                          backgroundColor: 'white'
                        }}
                        error={touched.city && get(errors, 'city.value', false)}
                        touched={touched.city}
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full pt-7">
                  <CommonSelect sort={true}
                    name="bankname"
                    value={values.bankname}
                    onChange={e => {
                      setFieldValue('bankname', {
                        value: e.value,
                        label: e.label
                      });
                      onBankChange(e);
                    }}
                    onBlur={() => {
                      setFieldTouched('bankname', true, true);
                    }}
                    options={bankListOptions}
                    isHoverEffect
                    stylesContainer={{
                      marginBottom: '0px',
                      fontSize: '40px',
                      height: '52px'
                    }}
                    dropdownStyle={{
                      top: '52px',
                      color: 'rgba(0,0,0,0.87)',
                      fontSize: '16px',
                      backgroundColor: '#fff',
                      alignItems: 'center',
                      fontFamily: 'Roboto',
                      fontWeight: 400
                    }}
                    styleText={{
                      fontSize: '14px',
                      padding: '0 6px',
                      backgroundColor: 'white'
                    }}
                    error={
                      touched.bankname && get(errors, 'bankname.value', false)
                    }
                    touched={touched.bankname}
                  />
                </div>
                {branchContact ? (
                  <div className="w-full pt-7 ">
                    <div className="grid grid-cols-2 mt-1">
                      <div className=" lg:p-2 md:p-3 p-1  mr-2">
                        <p className="text-grey-600 text-sm">SM Name</p>
                      </div>
                      <div className=" lg:p-2 md:p-3 p-1  mr-2">
                        {branchContact?.name}
                      </div>
                    </div>
                    <div className="grid grid-cols-2 mt-1">
                      <div className=" lg:p-2 md:p-3 p-1  mr-2">
                        <p className="text-grey-600 text-sm">Mobile Number</p>
                      </div>
                      <div className=" lg:p-2 md:p-3 p-1  mr-2">
                        +91 {branchContact?.phone}
                      </div>
                    </div>
                    <div className="grid grid-cols-2  mt-1">
                      <div className=" lg:p-2 md:p-3 p-1 mr-2">
                        <p className="text-grey-600 text-sm">Email ID</p>
                      </div>
                      <div className=" lg:p-2 md:p-3 p-1  mr-2">
                        {branchContact?.email}
                      </div>
                    </div>
                  </div>
                ) : null}
                <button
                  className="submitButton w-48 block"
                  type="submit"
                  disabled={
                    !cityOptions.length > 0 ||
                    !bankListOptions.length > 0 ||
                    !branchContact
                  }
                >
                  Send to Bank
                </button>
              </div>
            </div>
            <PopUp
              type={type}
              text={text}
              setShow={setShow}
              show={show}
              dontClose={!status == 400}
            />
          </Form>
        );
      }}
    </Formik>
  );
};
export default SendToBank;
